module.exports = __webpack_public_path__ + "img/dutyfree_hover_6b69a8e.webp";